import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../UserDashboard/UserDashboard.module.css";

export default function GroupEnrollment() {
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {/* ================= LEFT COLUMN ================= */}
        <div className={styles.colLeft}>
          {/* ===== Header ===== */}
          <section className={styles.card}>
            <div className={styles.cardHeader}>
              <h3>Inscrição no Grupo de Discussão</h3>
              <small className={styles.muted}>
                Terapia Baseada em Processos
              </small>
            </div>

            <p>
              Antes de concluir sua inscrição, leia atentamente as informações
              abaixo. A participação no grupo pressupõe concordância explícita
              com os termos apresentados.
            </p>
          </section>

          {/* ===== Termo ===== */}
          <section className={styles.card}>
            <div className={styles.cardHeader}>
              <h3>Termo de Consentimento e Condições</h3>
            </div>

            <div
              style={{
                maxHeight: "320px",
                overflowY: "auto",
                paddingRight: "6px",
              }}
            >
              <p>
                <strong>1. Natureza do grupo</strong>
              </p>
              <p>
                O Grupo de Discussão em Terapia Baseada em Processos é um espaço
                coletivo de estudo, reflexão e discussão clínica, voltado a
                profissionais da saúde interessados no desenvolvimento do
                raciocínio clínico a partir de uma perspectiva baseada em
                processos psicológicos.
              </p>
              <p>
                Este grupo tem caráter educativo e formativo, não constituindo
                supervisão clínica individual, psicoterapia, atendimento médico
                ou qualquer forma de prestação de serviço assistencial direto.
              </p>

              <p>
                <strong>2. Gravação e uso de conteúdo</strong>
              </p>
              <p>
                Declaro estar ciente de que os encontros do grupo serão gravados
                para fins de: acompanhamento interno das atividades do grupo;
                estudo e desenvolvimento contínuo da plataforma; produção de
                materiais educativos e formativos.
              </p>
              <p>
                As gravações poderão ser utilizadas, total ou parcialmente, em
                cursos, aulas, treinamentos, materiais institucionais e outros
                conteúdos relacionados à formação clínica, inclusive em
                ambientes digitais e mídias sociais, sempre com finalidade
                educativa.
              </p>
              <p>
                Compromete-se a organização a empregar esforços razoáveis para
                evitar a exposição indevida de participantes, preservando o
                caráter profissional e educativo do material.
              </p>

              <p>
                <strong>3. Sigilo e ética</strong>
              </p>
              <p>
                Comprometo-me a apresentar casos clínicos exclusivamente de
                forma anonimizada, abstendo-me de compartilhar qualquer
                informação que permita a identificação direta ou indireta de
                pacientes.
              </p>
              <p>
                Reconheço que a responsabilidade ética pela preservação do
                sigilo profissional é compartilhada entre todos os participantes
                do grupo, cabendo a cada um agir de acordo com os códigos de
                ética de sua profissão e a legislação vigente.
              </p>

              <p>
                <strong>4. Limites e expectativas</strong>
              </p>
              <p>
                Estou ciente de que: a participação no grupo não garante
                resultados clínicos específicos; as discussões têm caráter
                reflexivo e educativo; as decisões clínicas permanecem sob
                responsabilidade exclusiva de cada profissional em sua prática
                individual.
              </p>

              <p>
                <strong>5. Pagamento</strong>
              </p>
              <p>
                A participação no grupo está condicionada ao pagamento da taxa
                correspondente, processada por meio da plataforma Stripe,
                responsável pela intermediação segura das transações
                financeiras.
              </p>
              <p>
                Ao realizar a inscrição, declaro estar ciente do valor, da
                periodicidade da cobrança (quando aplicável) e das condições de
                cancelamento e reembolso informadas no momento da contratação.
              </p>
              <p>
                A plataforma não armazena dados sensíveis de pagamento, sendo
                estes tratados exclusivamente pelo provedor financeiro.
              </p>

              <p>
                <strong>6. Plataforma dos encontros</strong>
              </p>
              <p>
                Os encontros ao vivo do grupo serão realizados por meio da
                plataforma Google Meet, ou outra ferramenta equivalente, podendo
                variar conforme necessidades técnicas ou organizacionais.
              </p>
              <p>
                Reconheço que o acesso aos encontros está sujeito às condições
                técnicas da plataforma utilizada, incluindo conexão à internet,
                disponibilidade do serviço e políticas do provedor.
              </p>
            </div>

            <label
              style={{
                display: "flex",
                gap: "8px",
                marginTop: "12px",
                alignItems: "flex-start",
              }}
            >
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
              />
              <span>
                Declaro que compreendi integralmente as informações acima, tive
                a oportunidade de esclarecer dúvidas e concordo voluntariamente
                com os termos apresentados.
              </span>
            </label>
          </section>

          {/* ===== Actions ===== */}
          <section className={styles.card}>
            <div className={styles.meetingActions}>
              <button
                className={styles.primaryBtn}
                // disabled={!accepted}
                onClick={() =>
                  !accepted
                    ? alert(
                        "Para prosseguir é necessário concordar com os termos"
                      )
                    : navigate("/group-payment")
                }
              >
                Prosseguir para pagamento
              </button>

              <Link to="/" className={styles.openMeeting}>
                Voltar para a página inicial
              </Link>
            </div>
          </section>
        </div>

        {/* ================= RIGHT COLUMN ================= */}
        <div className={styles.colRight}>
          <section className={styles.card}>
            <h3>Transparência e ética</h3>
            <p className={styles.muted}>
              Este grupo foi estruturado para sustentar um espaço clínico
              responsável, com clareza de limites, respeito ético e alinhamento
              de expectativas.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
